import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { PlanTypeDTO } from 'src/app/models/Plans/PlanTypeDTO';
import { TableColumn } from 'src/app/models/TableColumn';
import { PlanService } from 'src/app/services/plan.service';

import { FormsModule } from '@angular/forms';
import { TableControlComponent } from '../../../shared/controls/table-control/table-control.component';
@Component({
    selector: 'app-plan-types',
    templateUrl: './plan-types.component.html',
    styleUrl: './plan-types.component.css',
    imports: [
        FormsModule,
        RouterModule,
        TableControlComponent,
    ]
})
export class PlanTypesComponent {

  planTypes: PlanTypeDTO[] = [];
  columns: TableColumn[] = [

    { key: 'planTypeId', header: 'ID', width: 80 },
    { key: 'name', header: 'Plan Type', width: 250 },
    { key: 'description', header: 'Description' },
    { key: 'frequencyId', header: 'Frequency', width: 250 },
    { key: 'isPool', header: 'Is Pool', width: 80 },
  ];

  actionButtons = [

    { label: 'edit', class: 'primary', icon: 'bi bi-pencil' },
    //{ label: 'archive', class: 'danger', icon: 'bi bi-archive' },

  ];

  /**
   *
   */
  constructor(private planService: PlanService, private router: Router) {
    
    
  }

  ngOnInit(): void {
    
       this.planService.GetPlanTypes().subscribe((data: PlanTypeDTO[]) => {
      this.planTypes = data;
    });
  }


  onAction(event: { action: string; item: PlanTypeDTO }): void {

    switch (event.action) {

      case 'edit':
        this.router.navigate(['/settings/plan-types/update/' + event.item.planTypeId], {
          //relativeTo: this.route,
          //state: { simData: sim },
        });
        break;
      // case 'archive':
      //   this.selectedTicket = event.item;
      //   bootstrap.Modal.getOrCreateInstance(document.getElementById('ticketArchiveConfirmationAlert')).show();
      //   break;
    }

  }
}
